class TreeMapConfig extends BaseItemConfig {
    metric: KnockoutObservable<number>;

    field: KnockoutObservable<number>;
    fieldAutoGrouping: KnockoutObservable<AutoGroupingEnum>;

    groupField: KnockoutObservable<number>;
    groupFieldAutoGrouping: KnockoutObservable<AutoGroupingEnum>;

    colorization: KnockoutObservable<string>;
    layout: KnockoutObservable<string>;

    colorizeGroups: KnockoutObservable<boolean>;
    startColor: KnockoutObservable<string>;
    endColor: KnockoutObservable<string>;
    formattingRule: KnockoutObservable<number>;

    label: TreeMapLabel;
    topBottomType: KnockoutObservable<number>;
    topBottomValue: KnockoutObservable<number>;

    maxValue: number;

    get allowEditDrilldown() { return true; }

    constructor(data: any) {
        super(data);

        this.metric = ko.observable(data.metric);

        this.field = ko.observable(data.field);
        this.fieldAutoGrouping = ko.observable(data.fieldAutoGrouping);

        this.groupField = ko.observable(data.groupField);
        this.groupFieldAutoGrouping = ko.observable(data.groupFieldAutoGrouping);

        this.colorization = ko.observable(data.colorization);
        this.layout = ko.observable(data.layout);

        this.colorizeGroups = ko.observable(data.colorizeGroups);
        this.startColor = ko.observable(data.startColor);
        this.endColor = ko.observable(data.endColor);
        this.formattingRule = ko.observable(data.formattingRule);

        this.label = new TreeMapLabel(data.label);
        this.topBottomType = ko.observable(data.topBottomType);
        this.topBottomValue = ko.observable(data.topBottomValue);
    }

    get allowDetailTab(): boolean {
        return true;
    }

    override updateReportAfterSaving(data) {
        this.field(data.field);
        this.fieldAutoGrouping(data.fieldAutoGrouping);
    }

    override updateDrilldownListRemovingTemplateId(tabOrWidget: ITabOrWidget, callback: Function = null) {
        callback?.();
    }
}

enum TreeMapColorizationEnum {
    Discrete = "discrete",
    Gradient = "gradient",
    Range = "range"
}

class TreeMapColumnInfo {
    index: number;
    queryName: string;
    autoGrouping: AutoGroupingEnum;
    groupingType: GroupingTypeEnum;
    dataType: DataTypeEnum;

    accountingStyle: boolean;
    decimalPlaces: number;
    metricFormat: FieldFormatEnum;
}

class TreeMapLabel {
    showMetric: KnockoutObservable<boolean>;
    unitFormat: KnockoutObservable<LabelFormatEnum>;
    decimalPlaces: KnockoutObservable<number>;
    format: KnockoutObservable<FieldFormatEnum>;

    constructor(data) {
        this.showMetric = ko.observable(data.showMetric);
        this.unitFormat = ko.observable(data.unitFormat);
        this.decimalPlaces = ko.observable(data.decimalPlaces);
        this.format = ko.observable(data.format);
    }
}